import { GetExternalAirlinesState } from './getExternalAirlines.types'

const initialState: GetExternalAirlinesState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
